import React from 'react';
import { Link } from 'react-router-dom';
const ARTICLES = [{
  title: 'Managing Seasonal Allergies',
  excerpt: 'Expert advice on identifying triggers and finding the right relief for your symptoms.'
}, {
  title: 'Heart Health Essentials',
  excerpt: 'Understanding blood pressure monitoring and heart-healthy lifestyle choices.'
}, {
  title: 'Immune System Support',
  excerpt: 'Practical tips for maintaining a strong immune system through nutrition and wellness.'
}];
export function AdviceSection() {
  return <section className="py-12 sm:py-24 bg-white" data-id="element-33">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-34">
        <h2 className="text-2xl sm:text-3xl font-black text-slate-900 mb-8 sm:mb-12 text-center" data-id="element-35">
          Advice You Can Trust
        </h2>
        <div className="grid md:grid-cols-3 gap-6 sm:gap-8" data-id="element-36">
          {ARTICLES.map((article, idx) => <div key={idx} className="bg-clean-grey p-6 sm:p-10 rounded-xl flex flex-col h-full" data-id="element-37">
              <div className="w-12 h-1 bg-clinical-blue mb-6 sm:mb-8" data-id="element-38"></div>
              <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-39">
                {article.title}
              </h3>
              <p className="text-slate-500 text-sm leading-relaxed mb-8 flex-grow" data-id="element-40">
                {article.excerpt}
              </p>
              <Link to="/services" className="text-clinical-blue text-xs font-bold uppercase tracking-widest hover:underline" data-id="element-41">
                Read Article
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}